export enum AuthorizationsEnum {

    /**
     * Données société
     */

    // Clients (fiche société)
    ClientCreate = 'client_create',
    ClientDelete = 'client_delete',
    ClientRead = 'client_read',
    ClientUpdate = 'client_update',
    // Contacts
    ClientContactCreate = 'clientcontact_create',
    ClientContactDelete = 'clientcontact_delete',
    ClientContactRead = 'clientcontact_read',
    ClientContactUpdate = 'clientcontact_update',
    // Utilisateurs
    ClientUserCreate = 'clientuser_create',
    ClientUserDelete = 'clientuser_delete',
    ClientUserRead = 'clientuser_read',
    ClientUserUpdate = 'clientuser_update',
    // Abonnements
    SubscriptionCreate = 'subscription_create',
    SubscriptionRead = 'subscription_read',
    // Associés
    ShareholderCreate = 'shareholder_create',
    ShareholderDelete = 'shareholder_delete',
    ShareholderRead = 'shareholder_read',
    ShareholderUpdate = 'shareholder_update',
    // Employés
    EmployeeCreate = 'employee_create',
    EmployeeDelete = 'employee_delete',
    EmployeeRead = 'employee_read',
    EmployeeUpdate = 'employee_update',
    // Invitations
    InviteCreate = 'invite_create',
    InviteDelete = 'invite_delete',
    InviteRead = 'invite_read',
    InviteUpdate = 'invite_update',

    /**
     * Module banque
     */

    BankingModule = 'banking_module',
    // Comptes bancaires
    BankAccountCreate = 'bankaccount_create',
    BankAccountDelete = 'bankaccount_delete',
    BankAccountMerge = 'bankaccount_merge',
    BankAccountRead = 'bankaccount_read',
    BankAccountReadBalance = 'bankaccount_read_balance',
    BankAccountUpdate = 'bankaccount_update',
    // Transactions bancaires
    BankAccountLineAllocate = 'bankaccountline_allocate',
    BankAccountLineCreate = 'bankaccountline_create',
    BankAccountLineDelete = 'bankaccountline_delete',
    BankAccountLineRead = 'bankaccountline_read',
    BankAccountLineRecordOverpayment = 'bankaccountline_record_overpayment',
    BankAccountLineUpdate = 'bankaccountline_update',
    BankAccountLineWriteOff = 'bankaccountline_write_off',
    // Règles d'affectation
    BankAccountRuleCreate = 'bankaccountrule_create',
    BankAccountRuleDelete = 'bankaccountrule_delete',
    BankAccountRuleRead = 'bankaccountrule_read',
    BankAccountRuleUpdate = 'bankaccountrule_update',
    // Relevés bancaires
    BankStatementCreate = 'bankstatement_create',
    BankStatementDelete = 'bankstatement_delete',
    BankStatementRead = 'bankstatement_read',
    BankStatementUpdate = 'bankstatement_update',
    // Lignes de relevé bancaire
    BankStatementLineUpdate = 'bankstatementline_update',
    // Transactions carte
    CardReceiptCreate = 'cardreceipt_create',
    CardReceiptDelete = 'cardreceipt_delete',
    CardReceiptRead = 'cardreceipt_read',
    CardReceiptUpdate = 'cardreceipt_update',
    PaymentProviderCreate = 'paymentprovider_create',
    PaymentProviderDelete = 'paymentprovider_delete',
    PaymentProviderRead = 'paymentprovider_read',
    PaymentProviderUpdate = 'paymentprovider_update',
    // Transactions en espèces
    CashTransactionCreate = 'cashtransaction_create',
    CashTransactionDelete = 'cashtransaction_delete',
    CashTransactionRead = 'cashtransaction_read',
    CashTransactionUpdate = 'cashtransaction_update',
    // Chèques
    ChequeCancel = 'cheque_cancel',
    ChequeCreate = 'cheque_create',
    ChequeDelete = 'cheque_delete',
    ChequeRead = 'cheque_read',
    ChequeRefuse = 'cheque_refuse',
    ChequeUpdate = 'cheque_update',
    ChequeValidate = 'cheque_validate',
    // Transactions cartes à débit différé
    CreditCardCreate = 'creditcard_create',
    CreditCardDelete = 'creditcard_delete',
    CreditCardRead = 'creditcard_read',
    CreditCardUpdate = 'creditcard_update',
    CreditCardTransactionCreate = 'creditcardtransaction_create',
    CreditCardTransactionDelete = 'creditcardtransaction_delete',
    CreditCardTransactionRead = 'creditcardtransaction_read',
    CreditCardTransactionUpdate = 'creditcardtransaction_update',
    // Remises de chèques
    DepositCreate = 'deposit_create',
    DepositDelete = 'deposit_delete',
    DepositDeposit = 'deposit_deposit',
    DepositRead = 'deposit_read',
    DepositUndeposit = 'deposit_undeposit',
    DepositUpdate = 'deposit_update',
    // Emprunts
    LoanCreate = 'loan_create',
    LoanDelete = 'loan_delete',
    LoanManageAttachments = 'loan_manage_attachments',
    LoanRead = 'loan_read',
    LoanUpdate = 'loan_update',

    /**
     * Module ventes
     */

    SalesModule = 'sales_module',
    // Partenaires
    PartnerCreate = 'partner_create',
    PartnerDelete = 'partner_delete',
    PartnerManageAttachments = 'partner_manage_attachments',
    PartnerMerge = 'partner_merge',
    PartnerRead = 'partner_read',
    PartnerUpdate = 'partner_update',
    // Contacts partenaires
    PartnerContactCreate = 'partnercontact_create',
    PartnerContactDelete = 'partnercontact_delete',
    PartnerContactRead = 'partnercontact_read',
    PartnerContactUpdate = 'partnercontact_update',
    // Identifiants de partenaires
    PartnerIdentifierCreate = 'partneridentifier_create',
    // Articles
    ProductCreate = 'product_create',
    ProductDelete = 'product_delete',
    ProductRead = 'product_read',
    ProductUpdate = 'product_update',
    // Groupes d'articles
    ProductGroupCreate = 'productgroup_create',
    ProductGroupDelete = 'productgroup_delete',
    ProductGroupRead = 'productgroup_read',
    ProductGroupUpdate = 'productgroup_update',
    // Titres de sections réutilisables (#1186)
    ProductSectionTitleCreate = 'productsectiontitle_create',
    ProductSectionTitleDelete = 'productsectiontitle_delete',
    ProductSectionTitleRead = 'productsectiontitle_read',
    ProductSectionTitleUpdate = 'productsectiontitle_update',
    // Devis
    QuotationBill = 'quotation_bill',
    QuotationCancel = 'quotation_cancel',
    QuotationClose = 'quotation_close',
    QuotationCreate = 'quotation_create',
    QuotationCreateAddendum = 'quotation_create_addendum',
    QuotationDelete = 'quotation_delete',
    QuotationDuplicate = 'quotation_duplicate',
    QuotationManageAttachments = 'quotation_manage_attachments',
    QuotationMarkAsSent = 'quotation_mark_as_sent',
    QuotationRead = 'quotation_read',
    QuotationRemind = 'quotation_remind',
    QuotationReopen = 'quotation_reopen',
    QuotationSend = 'quotation_send',
    QuotationUpdate = 'quotation_update',
    QuotationValidate = 'quotation_validate',
    // Échéanciers de devis
    PaymentScheduleCreate = 'paymentschedule_create',
    // Factures de vente
    SalesInvoiceAllocate = 'salesinvoice_allocate',
    SalesInvoiceCancel = 'salesinvoice_cancel',
    SalesInvoiceCreate = 'salesinvoice_create',
    SalesInvoiceCreditNote = 'salesinvoice_credit_note',
    SalesInvoiceDelete = 'salesinvoice_delete',
    SalesInvoiceDevalidate = 'salesinvoice_devalidate',
    SalesInvoiceDuplicate = 'salesinvoice_duplicate',
    SalesInvoiceManageAttachments = 'salesinvoice_manage_attachments',
    SalesInvoiceMarkAsSent = 'salesinvoice_mark_as_sent',
    SalesInvoiceModify = 'salesinvoice_modify',
    SalesInvoiceRead = 'salesinvoice_read',
    SalesInvoiceRecordPayment = 'salesinvoice_record_payment',
    SalesInvoiceRemind = 'salesinvoice_remind',
    SalesInvoiceSend = 'salesinvoice_send',
    SalesInvoiceUpdate = 'salesinvoice_update',
    SalesInvoiceValidate = 'salesinvoice_validate',
    SalesInvoiceWriteOff = 'salesinvoice_write_off',
    // Factures récurrentes
    RecurringInvoiceActivate = 'recurringinvoice_activate',
    RecurringInvoiceCreate = 'recurringinvoice_create',
    RecurringInvoiceDelete = 'recurringinvoice_delete',
    RecurringInvoiceRead = 'recurringinvoice_read',
    RecurringInvoiceUpdate = 'recurringinvoice_update',
    // Fiches info vente
    SellingInfoRecordCreate = 'sellinginforecord_create',
    SellingInfoRecordDelete = 'sellinginforecord_delete',
    SellingInfoRecordRead = 'sellinginforecord_read',
    SellingInfoRecordUpdate = 'sellinginforecord_update',

    /**
     * Module achats
     */

    PurchasingModule = 'purchasing_module',
    // Factures d'achat
    PurchaseInvoiceAllocate = 'purchaseinvoice_allocate',
    PurchaseInvoiceCancel = 'purchaseinvoice_cancel',
    PurchaseInvoiceCreate = 'purchaseinvoice_create',
    PurchaseInvoiceCreditNote = 'purchaseinvoice_credit_note',
    PurchaseInvoiceDelete = 'purchaseinvoice_delete',
    PurchaseInvoiceDevalidate = 'purchaseinvoice_devalidate',
    PurchaseInvoiceDuplicate = 'purchaseinvoice_duplicate',
    PurchaseInvoiceManageAttachments = 'purchaseinvoice_manage_attachments',
    PurchaseInvoiceMarkAsSent = 'purchaseinvoice_mark_as_sent',
    PurchaseInvoiceModify = 'purchaseinvoice_modify',
    PurchaseInvoiceRead = 'purchaseinvoice_read',
    PurchaseInvoiceRecordPayment = 'purchaseinvoice_record_payment',
    PurchaseInvoiceRemind = 'purchaseinvoice_remind',
    PurchaseInvoiceSend = 'purchaseinvoice_send',
    PurchaseInvoiceUpdate = 'purchaseinvoice_update',
    PurchaseInvoiceValidate = 'purchaseinvoice_validate',
    PurchaseInvoiceWriteOff = 'purchaseinvoice_write_off',

    /**
     * Module comptabilité
     */

    AccountingModule = 'accounting_module',
    // Comptes comptables
    AccountCreate = 'account_create',
    AccountDelete = 'account_delete',
    AccountMerge = 'account_merge',
    AccountRead = 'account_read',
    AccountUpdate = 'account_update',
    // Écritures comptables
    AccountEntryCreate = 'accountentry_create',
    AccountEntryDelete = 'accountentry_delete',
    AccountEntryRead = 'accountentry_read',
    AccountEntryUpdate = 'accountentry_update',
    // Périodes comptables
    AccountingPeriodCreate = 'accountingperiod_create',
    AccountingPeriodDelete = 'accountingperiod_delete',
    AccountingPeriodRead = 'accountingperiod_read',
    AccountingPeriodUpdate = 'accountingperiod_update',
    // Journaux comptables
    JournalCreate = 'journal_create',
    JournalDelete = 'journal_delete',
    JournalMerge = 'journal_merge',
    JournalRead = 'journal_read',
    JournalUpdate = 'journal_update',
    // Axes analytiques
    AnalyticalAxisCreate = 'analyticalaxis_create',
    AnalyticalAxisDelete = 'analyticalaxis_delete',
    AnalyticalAxisRead = 'analyticalaxis_read',
    AnalyticalAxisUpdate = 'analyticalaxis_update',
    // Sections analytiques
    AnalyticalSectionCreate = 'analyticalsection_create',
    AnalyticalSectionDelete = 'analyticalsection_delete',
    AnalyticalSectionRead = 'analyticalsection_read',
    AnalyticalSectionUpdate = 'analyticalsection_update',
    // Clés de répartition analytiques
    AnalyticalKeyCreate = 'analyticalkey_create',
    AnalyticalKeyDelete = 'analyticalkey_delete',
    AnalyticalKeyRead = 'analyticalkey_read',
    AnalyticalKeyUpdate = 'analyticalkey_update',
    // Défauts analytiques
    AnalyticalDefaultCreate = 'analyticaldefault_create',
    AnalyticalDefaultDelete = 'analyticaldefault_delete',
    AnalyticalDefaultRead = 'analyticaldefault_read',
    AnalyticalDefaultUpdate = 'analyticaldefault_update',
    // Subventions
    SubsidyCreate = 'subsidy_create',
    SubsidyDelete = 'subsidy_delete',
    SubsidyRead = 'subsidy_read',
    SubsidyUpdate = 'subsidy_update',
    // Rémunérations
    RemunerationCreate = 'remuneration_create',
    RemunerationDelete = 'remuneration_delete',
    RemunerationRead = 'remuneration_read',
    RemunerationUpdate = 'remuneration_update',
    RemunerationValidate = 'remuneration_validate',

    /**
     * Module Fiscalité
     */

    TaxationModule = 'taxation_module',
    // TGC
    TGCDeclarationCreate = 'tgcdeclaration_create',
    TGCDeclarationDelete = 'tgcdeclaration_delete',
    TGCDeclarationDownload = 'tgcdeclaration_download',
    TGCDeclarationRead = 'tgcdeclaration_read',
    TGCDeclarationUpdate = 'tgcdeclaration_update',
    TGCDeclarationValidate = 'tgcdeclaration_validate',

    /**
     * Reporting
     */

    // Exports d'écritures comptables
    AccountEntryExportCreate = 'accountentryexport_create',
    AccountEntryExportDelete = 'accountentryexport_delete',
    AccountEntryExportRead = 'accountentryexport_read',
    AccountEntryExportUpdate = 'accountentryexport_update',

    /**
     * Module messagerie
     */
    EmailCreate = 'email_create',
    EmailDelete = 'email_delete',
    EmailManageAttachments = 'email_manage_attachments',
    EmailRead = 'email_read',
    EmailSend = 'email_send',
    EmailUpdate = 'email_update',
    // Messages de conversation
    ConversationItemSend = 'conversationitem_send',

    /**
     * Reporting
     */
    BankAccountsBalancesWidget = 'widget_bankaccountbalances_read',
    ChargesWidget = 'widget_charges_read',
    DSOWidget = 'widget_dso_read',
    MonthlySummaryWidget = 'widget_monthlysummary_read',
    PurchasingDebtsWidget = 'widget_purchasingdebts_read',
    SalesDebtsWidget = 'widget_salesdebts_read',
    WatchListWidget = 'widget_watchlist_read',

    /**
     * Paramétrages
     */

    CustomizingCreate = 'customizing_create',
    CustomizingDelete = 'customizing_delete',
    CustomizingRead = 'customizing_read',
    CustomizingUpdate = 'customizing_update',

    /**
     * Clés API
     */
    ApiKeyManage = 'apikey_manage',
    ApiKeyRead = 'apikey_read',

    /**
     * Adresses
     */
    AddressCreate = 'address_create',
    AddressDelete = 'address_delete',
    AddressRead = 'address_read',
    AddressUpdate = 'address_update',

    /**
     * Consentements légaux
     */
    LegalConsentCreate = 'legalconsent_create',
    LegalConsentRead = 'legalconsent_read',
}